module.exports = __webpack_public_path__ + "media/images/noodles-73c0f20a13dad5d337dfdad068b1962f.png";